import { render } from "./d-bet-area.vue?vue&type=template&id=5b462e80&scoped=true&ts=true"
import script from "./d-bet-area.vue?vue&type=script&lang=ts"
export * from "./d-bet-area.vue?vue&type=script&lang=ts"

import "./d-bet-area.vue?vue&type=style&index=0&id=5b462e80&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b462e80"]])

export default __exports__